import React, { useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import './Contact.css'
import emailjs from '@emailjs/browser';
// import img from '../../images/contact.jpg'

const Result = () => {
  return (
      <p style={{color:'white'}} >Your massage han been successfully</p>
  )
}

const Contact = () => {
  const [result, setResult] = useState(false)

  const { register, handleSubmit } = useForm();
  const onSubmit = data => console.log(data);
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_2ditwxr', 'template_0ecdrgs', e.target, 'ohDTcyspPP7i-kk5G')
      .then((result) => {
          console.log(result.text);
      }, (error) => {
          console.log(error.text);
      });
      e.target.reset()
  };


  return (
    // onBlur={handleSubmit(onSubmit)} 
    <div className='background-img '>
     
     <div className='from-cont '>
     <form ref={form} onSubmit={sendEmail} onBlur={handleSubmit(onSubmit)}  action="" className='box'  method='post'>
        <h1 className='text-font'  >Contact Us</h1>
        <input className='input-style' type="name"name="name"  placeholder='name' required  {...register("firstName")}  
     
      />

        <input className='input-style' type="email" name="email"  placeholder='email'  required {...register("email")} 
     
     />

        <textarea className='input-style'  id="" name="massage" required {...register("description" )} placeholder="Description"   />


        <input className='submit-button' type="submit" name='' value='submit' 
    
     />
        <div>
          {result ? <Result></Result> : null}
        </div>
      </form>
     </div>
     {/* <div className='col-md-5 col-lg-5 col-sm-5'>
       <img src={img} alt="" />
     </div> */}
    </div>
  );
};

export default Contact;